import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useRestrictedItemsSectionsList } from "../../Pages.hook";
import { fields } from "../../constants";

export const AddEditRestrictedItemsSectionsList = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editNewsData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetcheditNews,
  } = useRestrictedItemsSectionsList(query.get("editId") || "");

  const {
    data: newsById,
    isLoading: isLoadingNews,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetcheditNews();
    }
  }, [query.get("editId"), query.get("id")]);

  const editNews = editNewsData as any;
  console.log(editNews?.[0], "datanews");

  const newsFormConfig: FormConfig = {
    initialValues: {
      english_title: decodeHTML(
        newsById ? newsById.payload.english_title : editNewsData ? editNewsData?.[0]?.english_title : ""
      ),
      malay_title: decodeHTML(
        newsById ? newsById.payload.malay_title : editNewsData ? editNewsData?.[0]?.malay_title : ""
      ),
      mandarin_title: decodeHTML(
        newsById ? newsById.payload.mandarin_title : editNewsData ? editNewsData?.[0]?.mandarin_title : ""
      ),
      image: newsById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "newsImage.png",
              status: "done",
              url: newsById?.payload?.image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "newsImage.png",
              status: "done",
              url: editNewsData?.[0]?.image,
            },
          ]),
    },
    fields: fields.restrictedItemsCheckedInCabinRestrictionsImage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Pages",
      subModule: `travellersInfo_lagsAndRestrictedItems_restrictedItems_${query.get("type")}`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        image_section:
          query.get("type") === "restrictedItemsCheckedInCabinRestrictionsImage" ? "checkedin" : "cabinonly",
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingNews}
      title={`${query.get("type") === "restrictedItemsCheckedInCabinRestrictionsImage" ? "Edit Restricted Items Checked-In & Cabin Restrictions Image" : "Edit Restricted Items Cabin-Only Restrictions Image"}`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingNews || drilldownLoading}
        config={newsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/restricted/item/section-two/${editNewsData?.[0]?.nid || newsById?.payload?.nid}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
